import { Box, Button, Checkbox, Container, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { format, parseISO, isSaturday, setHours, differenceInMinutes, setMinutes, isSunday } from "date-fns";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AddIcon from '@mui/icons-material/Add';

interface Props {
  token: string;
  kayttajaId: number;
  suurinJarjestysNum: number;
  setSuurinJarjestysNum: (suurinJarjestysNum: number) => void;
}



interface TrainInfo {
  trainNumber: number;
  departureDate: string;
  operatorUICCode: number;
  operatorShortCode: string;
  trainCategory: string;
  journeySections: {
    attapId: number;
    beginTimeTableRow: {
      stationShortCode: string;
      stationUICCode: number;
      countryCode: string;
      type: string;
      scheduledTime: string;
    };
    endTimeTableRow: {
      stationShortCode: string;
      stationUICCode: number;
      countryCode: string;
      type: string;
      scheduledTime: string;
    };
    locomotives: any[];
    maximumSpeed: number;
    saapAttapId: number;
    totalLength: number;
    wagons: any[];
  }[];
}
export interface Vuoro {
  id: number;
  vuoroalkaa: Date;
  vuoroloppuu: Date;
  tyoaika: number;
  latunnit: number;
  sutunnit: number;
  yotunnit: number;
  iltatunnit: number;
  matkatunnit: number;
  paivystystunnit: number;
  tsl: boolean;
  userid: number;
  junat: Juna[];
}

export interface Juna {
  id: number;                          // id
  junanumero: number;                 // Junanumero
  pvm: Date;                          // Päivämäärä
  mista: string;                      // Lähtöpaikka
  mihin: string;                      // Kohdepaikka
  veturi: number;                     // Veturin numero
  akselit: number;                    // Akselit
  pituus: number;                     // Pituus
  junapaino: number;                  // Junan paino
  JP: number;                         // Junan paino
  JPP: number;                        // Junan paino
  lahtoaika: Date;                    // Lähtöaika
  saapumisaika: Date;                 // Saapumisaika
  lahtoaikam: number;                   // Lähtöaika (m)
  saapumisaikam: number;                // Saapumisaika (m)
  kmM: number;                        // KM M
  kmT: number;                        // KM T
  vapaateksti: string;                   // Käyttähän vapaa teksti
  jarjestysNum: number;               // Junan järjestysnumero
  matkustus: boolean;                 // Pakettimatka?

}

interface JunaErrors {
  pvm?: string;
  junanumero?: string;
  mista?: string;
  mihin?: string;
  kmM?: string;
  kmT?: string;
  veturi?: string;
  akselit?: string;
  pituus?: string;
  junapaino?: string;
  JP?: string;
  JPP?: string;
  lahtoaika?: string;
  lahtoaikam?: string;
  saapumisaika?: string;
  saapumisaikam?: string;
}


const initialJuna: Juna = {
  id: 0,
  junanumero: 0,
  pvm: new Date(),
  mista: "",
  mihin: "",
  veturi: 0,
  akselit: 0,
  pituus: 0,
  junapaino: 0,
  JP: 0,
  JPP: 0,
  lahtoaika: new Date(),
  saapumisaika: new Date(),
  lahtoaikam: 0,
  saapumisaikam: 0,
  kmM: 0,
  kmT: 0,
  vapaateksti: "",
  jarjestysNum: 0,
  matkustus: false,

};

const initialVuoro = {
  id: 0,
  junanumero: "",
  pvm: new Date(),
  mista: "",
  mihin: "",
  veturi: 0,
  akselit: 0,
  pituus: 0,
  junapaino: 0,
  JP: 0,
  JPP: 0,
  lahtoaika: new Date(),
  saapumisaika: new Date(),
  lahtoaikam: 0,
  saapumisaikam: 0,
  vuoroalkaa: new Date(),
  vuoroloppuu: new Date(),
  tyoaika: 0,
  latunnit: 0,
  sutunnit: 0,
  yotunnit: 0,
  iltatunnit: 0,
  matkatunnit: 0,
  paivystystunnit: 0,
  tsl: false,
  kmM: 0,
  kmT: 0,
  userid: 0,
  junat: [],
};


interface JunanAsemat {
  trainNumber: number;
  departureDate: string;
  operatorUICCode: number;
  operatorShortCode: string;
  trainType: string;
  trainCategory: string;
  commuterLineID: string;
  runningCurrently: boolean;
  cancelled: boolean;
  version: number;
  timetableType: string;
  timetableAcceptanceDate: string;
  timeTableRows: TimeTableRow[];
}

interface TimeTableRow {
  stationShortCode: string;
  stationUICCode: number;
  countryCode: string;
  type: string;
  trainStopping: boolean;
  commercialStop?: boolean;
  commercialTrack: string;
  cancelled: boolean;
  scheduledTime: string;
  actualTime?: string;
  differenceInMinutes: number;
  causes: any[];
  trainNumber: number;
  trainReady?: TrainReady;
  liveEstimateTime?: string;
  estimateSource?: string;
  omaEtaisyys: number;
  omaEstimate: number;
}

interface TrainReady {
  source: string;
  accepted: boolean;
  timestamp: string;
}




const Kirjaa: React.FC<Props> = (props: Props) => {



  //console.log("Propsi järjestysnumero:" + props.suurinJarjestysNum);

  const location = useLocation();
  const navigate: NavigateFunction = useNavigate();


  const scrolli = useRef<HTMLDivElement | null>(null);

  const [muokkausmoodi, setMuokkausmoodi] = useState<boolean>(false);
  const [jarjestysNum, setjarjestysNum] = useState<number>(0);

  const [junat, setJunat] = useState<Juna[]>([]);
  const [trainCategory, setTrainCategory] = useState<string>("");
  const [newErrors, setNewErrors] = useState<JunaErrors>({});
  const [asematiedot, setAsematiedot] = useState<JunanAsemat | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [selectedStation, setSelectedStation] = useState<string>("");
  const [selectedStationTo, setSelectedStationTo] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [vuoro, setVuoro] = useState<Vuoro>(initialVuoro);

  const [juna, setJuna] = useState(initialJuna);

  const [aikavalittu, setAikavalittu] = useState<boolean>(false);
  const [muotoiltuAikavali, setMuotoiltuAikavali] = useState('');
  const [matkatunnit, setMatkatunnit] = useState<string>("");

  const [templateJuna, setTemplateJuna] = useState<Vuoro[]>([]);
  const [templateSelectedJunaId, setTemplateSelectedJunaId] = useState<number[]>([]);





  const [selectedJunaId, setSelectedJunaId] = useState<number>(0);

  const haeData = async (junanumero: number): Promise<void> => {
    setLoading(true);
    setError(null);
    setAsematiedot(null);
    try {

      const pvm = format(new Date(juna.pvm), 'yyyy-MM-dd');

      const yhteys = await fetch(`https://rata.digitraffic.fi/api/v1/trains/${pvm}/${junanumero}`);
      if (!yhteys.ok) {
        throw new Error('Junan tietoja ei löytynyt.');
      }



      const data: JunanAsemat[] = await yhteys.json();

      if (Array.isArray(data) && data.length > 0) {
        const junatieto = data[0];
        setTrainCategory(junatieto.trainCategory);
        if (junatieto.timeTableRows && Array.isArray(junatieto.timeTableRows)) {

          setAsematiedot({ ...junatieto, timeTableRows: junatieto.timeTableRows });


        } else {
          throw new Error('Virheelliset asematiedot');
        }
      } else {
        throw new Error('Juna ei löytynyt.');
      }
    } catch (error) {
      console.error('Virhe haussa:', error);
      setError(error instanceof Error ? error.message : "Virhe tietojen haussa");
    } finally {
      setLoading(false);
    }


  };




  const peruutaMuokkaus = () => {
    setSelectedJunaId(0);
  }

  const muokkaaJunaa = () => {
    setSelectedJunaId(0);

  }

  const handleChangeJuna = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    setJuna((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));


    if (name === 'junanumero' && value) {
      haeData(Number(value));
      fetchTrainData(Number(value));
    }






    /// ****** Lasketaan jarrupainoprosentti

    if (name === 'junapaino' && value && juna.JP) {
      let JPP = Math.floor((juna.JP / Number(value)) * 100);
      setJuna((prev) => ({
        ...prev,
        JPP: JPP,
      }))
    }

    if (name === 'JP' && value && juna.junapaino) {
      let JPP = Math.floor((Number(value) / juna.junapaino) * 100);
      setJuna((prev) => ({
        ...prev,
        JPP: JPP,
      }))
    }




  }


  const toggleJunaSelection = (template: Juna) => {
    // Tarkistetaan, onko juna jo valittu
    if (templateSelectedJunaId.includes(template.id)) {
      return; // Ei tehdä mitään, jos juna on jo valittu
    }

    // Lisätään uusi juna listaan ja kasvatetaan järjestysnumeroa


    setJunat((prevJunat) => {


      //TODO: Tässä on jotain hämärää päivämäärässä
      const newJuna = { ...template, jarjestysNum: jarjestysNum, id: junat.length + 1, pvm: new Date() };


      // Lisätään uusi juna junat-listaan
      return [...prevJunat, newJuna];
    });

    //console.log("Junat:  " + JSON.stringify(junat));
    // Pidetään valittu juna visuaalisesti valittuna
    setTemplateSelectedJunaId((prevSelected) => [
      ...prevSelected,
      template.id, // Varmistetaan, että juna on valittu
    ]);

    // Poistetaan juna template-listasta, koska ei voi peruuttaa
    setTemplateJuna((prevTemplate) =>
      prevTemplate.filter((j) => j.id !== template.id)
    );

    setjarjestysNum((prevNum) => prevNum + 1);
  };


  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;

    setVuoro((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value === "" ? "" : Number(value),
    }));







  };


  const handleTallennaTyovuoro = async (event: React.MouseEvent<HTMLButtonElement>) => {

    if (!muokkausmoodi) {


      if (junat[0].mista !== junat[junat.length - 1].mihin && !vuoro.tsl) {
        const userResponse = window.confirm("Vuoro ei pääty aloitusasemalle. Haluatko kirjata viimeisen junan jälkeen työhönsidonnaisuuslisän?");
        vuoro.tsl = userResponse;
      }
      vuoro.userid = props.kayttajaId;






      try {
        const yhteys = await fetch("/api/kirjaa", {
          method: "POST",
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            tyoaika: vuoro.tyoaika,
            vuoroalkaa: vuoro.vuoroalkaa,
            vuoroloppuu: vuoro.vuoroloppuu,
            latunnit: vuoro.latunnit,
            sutunnit: vuoro.sutunnit,
            yotunnit: vuoro.yotunnit,
            iltatunnit: vuoro.iltatunnit,
            matkatunnit: vuoro.matkatunnit,
            paivystystunnit: vuoro.paivystystunnit,
            tsl: vuoro.tsl,
            userid: vuoro.userid,
            junat: junat.map(juna => ({
              junanumero: juna.junanumero,
              pvm: juna.pvm,
              mista: juna.mista,
              mihin: juna.mihin,
              veturi: juna.veturi,
              akselit: juna.akselit,
              pituus: juna.pituus,
              junapaino: juna.junapaino,
              JP: juna.JP,
              JPP: juna.JPP,
              lahtoaika: juna.lahtoaika,
              saapumisaika: juna.saapumisaika,
              lahtoaikam: juna.lahtoaikam,
              saapumisaikam: juna.saapumisaikam,
              kmM: juna.kmM,
              kmT: juna.kmT,
              vapaateksti: juna.vapaateksti,
              jarjestysNum: juna.jarjestysNum,
              matkustus: juna.matkustus,
            }))
          })
        });

        if (yhteys.status === 200) {
          console.log("Työvuoro tallennettu", vuoro);
          navigate("/");
        } else {
          alert('Tallennuksessa tapahtui virhe!');
        }
      } catch (error) {
        console.error("Fetch error:", error);
        alert('Tallennuksessa tapahtui virhe!');
      }
    }
    else {
      if (muokkausmoodi) {
        try {
          const yhteys = await fetch(`/api/kirjaa/updateJuna`, {
            method: "PUT",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: vuoro.id,
              tyoaika: vuoro.tyoaika,
              vuoroalkaa: vuoro.vuoroalkaa,
              vuoroloppuu: vuoro.vuoroloppuu,
              latunnit: vuoro.latunnit,
              sutunnit: vuoro.sutunnit,
              yotunnit: vuoro.yotunnit,
              iltatunnit: vuoro.iltatunnit,
              matkatunnit: vuoro.matkatunnit,
              paivystystunnit: vuoro.paivystystunnit,
              tsl: vuoro.tsl,
              userid: vuoro.userid,
              junat: junat.map(juna => ({
                junanumero: juna.junanumero,
                pvm: juna.pvm,
                mista: juna.mista,
                mihin: juna.mihin,
                veturi: juna.veturi,
                akselit: juna.akselit,
                pituus: juna.pituus,
                junapaino: juna.junapaino,
                JP: juna.JP,
                JPP: juna.JPP,
                lahtoaika: juna.lahtoaika,
                saapumisaika: juna.saapumisaika,
                lahtoaikam: juna.lahtoaikam,
                saapumisaikam: juna.saapumisaikam,
                kmM: juna.kmM,
                kmT: juna.kmT,
                vapaateksti: juna.vapaateksti,
                jarjestysNum: juna.jarjestysNum,
                matkustus: juna.matkustus,
              }))
            })
          });

          if (yhteys.status === 200) {
            console.log("Työvuoro päivitetty", vuoro);
            navigate("/");
          } else {
            alert('Päivityksessä tapahtuiiii virhe!');

          }
        } catch (error) {
          console.error("Fetch error:", error);
          alert('Päivityksessä tapahtui virhe!');
        }
      }

    }

  };



  const handleStationChange = (event: SelectChangeEvent<string>) => {
    setSelectedStation(event.target.value); // Päivitetään pudotusvalikon tila



    setJuna(prevJuna => {
      const distanceInKm = selectedStation
        ? Math.round(getDistance(selectedStationTo, event.target.value) / 1000)
        : 0;

      const updatedJuna = {
        ...prevJuna,
        mista: event.target.value,
        ...(selectedStation === 'HKI' && selectedStationTo === 'HKI'
          ? { kmM: 52, kmT: 0 } // Pakotetaan arvot HKI-HKI tapauksessa
          : {
            kmM: trainCategory !== "Cargo" ? distanceInKm : 0,
            kmT: trainCategory === "Cargo" ? distanceInKm : 0
          }
        )
      };

      return updatedJuna;
    });





  };


  const handleStationChangeTo = (event: SelectChangeEvent<string>) => {
    setSelectedStationTo(event.target.value);

    setJuna(prevJuna => {
      const distanceInKm = prevJuna.mista
        ? Math.round(getDistance(event.target.value, prevJuna.mista) / 1000)
        : 0;

      const updatedJuna = {
        ...prevJuna,
        mihin: event.target.value,
        ...(prevJuna.mista === 'HKI' && event.target.value === 'HKI'
          ? { kmM: 52, kmT: 0 } // Pakotetaan arvot HKI-HKI tapauksessa
          : {
            kmM: trainCategory !== "Cargo" ? distanceInKm : 0,
            kmT: trainCategory === "Cargo" ? distanceInKm : 0
          }
        )
      };

      return updatedJuna;
    });
  };




  const fetchTrainData = async (trainNumber: number) => {
    try {
      const pvm = format(new Date(juna.pvm), 'yyyy-MM-dd');
      const response = await fetch(`https://rata.digitraffic.fi/api/v1/compositions/${pvm}/${trainNumber}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const trainInfo: TrainInfo = await response.json();

      //console.log(trainInfo);

      let totalLength = 0;

      if (trainInfo) {
        const sectionIndex = trainInfo.journeySections.findIndex(
          section =>
            section.beginTimeTableRow.stationShortCode === selectedStation ||
            section.endTimeTableRow.stationShortCode === selectedStation
        );

        if (sectionIndex !== -1) {
          totalLength = trainInfo.journeySections[sectionIndex].totalLength;
          //   console.log(sectionIndex + ": " + totalLength);




          const akselitLUT = new Map<number, number>([
            [152, 24],
            [160, 24],
            [178, 28],
            [205, 32],
            [336, 52],
            [337, 52],
            [369, 56],
            [377, 56],
            [401, 60],
            [460, 68],
          ]);

          const akselit = akselitLUT.get(totalLength) ?? 0;


          setJuna((prevJuna) => ({
            ...prevJuna,
            pituus: totalLength,
            akselit: akselit,
          }));
        } else {


          console.log(`Station ${selectedStation} not found in any journey section.`);

          let foundPreviousStation = false;


          for (let i = uniqueStations.indexOf(selectedStation) - 1; i >= 0; i--) {
            const previousStation = uniqueStations[i];
            //  console.log(`Checking previous station: ${previousStation}`);


            const previousSectionIndex = trainInfo.journeySections.findIndex(
              section =>
                section.beginTimeTableRow.stationShortCode === previousStation ||
                section.endTimeTableRow.stationShortCode === previousStation
            );

            if (previousSectionIndex !== -1) {
              totalLength = trainInfo.journeySections[previousSectionIndex].totalLength;
              //  console.log(previousSectionIndex + ": " + totalLength);
              foundPreviousStation = true;
              break;
            }
          }

          if (!foundPreviousStation) {
            console.log('No previous station found in the list.');
            totalLength = 0;
          }





          setJuna((prevJuna) => ({
            ...prevJuna,
            pituus: totalLength,
          }));
        }
      } else {
        console.log('Train information not found for the given train number.');


        setJuna((prevJuna) => ({
          ...prevJuna,
          pituus: 0,
        }));
      }
    } catch (error) {
      console.error('Failed to fetch train data:', error);


      setJuna((prevJuna) => ({
        ...prevJuna,
        pituus: 0,
      }));
    }
  };




  const handleDelete = (id: number) => {
    setJunat(prevJunat => prevJunat.filter(juna => juna.id !== id));
  };

  const handleEdit = (id: number) => {




    if (selectedJunaId) {
      if (id != selectedJunaId) {
        return; // Varmistetaan että muuokkaus täytyy lopettaa ennenkuin voi valita uuden junan muokkaukseen
      }

    }



    if (selectedJunaId === id) {
      setJunat(prevJunat =>
        prevJunat.map(j =>
          j.id === selectedJunaId
            ? {
              ...j,
              ...juna,
              mista: selectedStation,
              mihin: selectedStationTo,
              pvm: new Date(juna.pvm),
              lahtoaika: new Date(juna.lahtoaika),
              saapumisaika: new Date(juna.saapumisaika),
              jarjestysNum: jarjestysNum,
            }
            : j
        )
      );

      haeData(Number(selectedJunaId));
      fetchTrainData(Number(selectedJunaId));


      setSelectedJunaId(0);

      setjarjestysNum(props.suurinJarjestysNum + 1);




      return;
    }






    const selectedJuna = junat.find(juna => juna.id === id);


    if (selectedJuna) {
      setJuna({
        ...selectedJuna,
        pvm: new Date(selectedJuna.pvm),
        lahtoaika: new Date(selectedJuna.lahtoaika),
        saapumisaika: new Date(selectedJuna.saapumisaika),

      });


      setSelectedStation(selectedJuna.mista);
      setSelectedStationTo(selectedJuna.mihin);
      setSelectedJunaId(id);
      setjarjestysNum(selectedJuna.jarjestysNum);
    }
  };





  useEffect(() => {
    if (selectedStation && asematiedot?.timeTableRows) {


      fetchTrainData(juna.junanumero);


      const departureRow = asematiedot.timeTableRows.find(
        (row) => row.stationShortCode === selectedStation && row.type === 'DEPARTURE'
      );

      if (departureRow) {
        const departureTime = parseISO(departureRow.scheduledTime);

        const lateTime = departureRow.differenceInMinutes;



        setJuna((prevJuna) => ({ ...prevJuna, lahtoaika: departureTime, lahtoaikam: Number(lateTime) }));

      } else {



        setJuna((prevJuna) => ({ ...prevJuna, lahtoaika: new Date('1970-01-01T00:00:00Z') }));
      }
    }
  }, [selectedStation, asematiedot]);



  useEffect(() => {

    if (!props.token) {
      navigate("/login");
      return;
    }



    const { vuoroid } = location.state || {};
    // console.log("Vuoro staten kautta: " + vuoroid);

    setjarjestysNum(props.suurinJarjestysNum + 1);



    if (vuoroid) {
      fetch(`/api/ajot/${vuoroid}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${props.token}`
        }
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          const vuoroData = data;


          setVuoro((prevVuoro) => ({
            ...prevVuoro,
            id: vuoroid,
            pvm: new Date(vuoroData.pvm),
            vuoroalkaa: new Date(vuoroData.vuoroalkaa),
            vuoroloppuu: new Date(vuoroData.vuoroloppuu),
            tyoaika: vuoroData.tyoaika,
            latunnit: vuoroData.latunnit,
            sutunnit: vuoroData.sutunnit,
            yotunnit: vuoroData.yotunnit,
            iltatunnit: vuoroData.iltatunnit,
            matkatunnit: vuoroData.matkatunnit,
            paivystystunnit: vuoroData.paivystystunnit,
            tsl: vuoroData.tsl,
            userid: vuoroData.userid,
            juna: vuoroData.juna,


          }));

          //  console.log("Juna: " + JSON.stringify(vuoroData.junat));

          setJunat(vuoroData.junat);
          setMuokkausmoodi(true);

        })
        .catch((error) => {
          console.error("Error fetching Vuoro data:", error);
        });

    }











  }, [props.token, location]);

  useEffect(() => {

    if (vuoro.tyoaika > 0) {
      setAikavalittu(true);
    }


  }, [vuoro.tyoaika])



  const { getRoute, getDistance } = require('ratakilometri')()

  useEffect(() => {

    if (selectedStationTo && asematiedot?.timeTableRows) {


      //  console.log('Selected station To:', selectedStationTo);


      const arrivalRow = asematiedot.timeTableRows.find(
        (row) => row.stationShortCode === selectedStationTo && row.type === 'ARRIVAL'
      );

      //console.log('Found arrival row:', arrivalRow);
      if (arrivalRow) {
        const arrivalTime = parseISO(arrivalRow.scheduledTime);

        const lateTime = arrivalRow.differenceInMinutes;


        setJuna((prevJuna) => ({ ...prevJuna, saapumisaika: arrivalTime, saapumisaikam: Number(lateTime) }));
      } else {
        setJuna((prevJuna) => ({ ...prevJuna, saapumisaika: new Date('1970-01-01T00:00:00Z') }));
      }
    }
  }, [selectedStationTo, selectedStation, asematiedot]);


  const handleSubmit = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();

  };


  const lisaaTyovuoroon = () => {

    let errors: JunaErrors = {};

    if (!juna.pvm) errors.pvm = "Päivämäärä on pakollinen";
    if (!juna.junanumero) errors.junanumero = "Junanumero on pakollinen";
    if (!selectedStation) errors.mista = "Lähtöasema on pakollinen";
    if (!selectedStationTo) errors.mihin = "Määräasema on pakollinen";

    if (!juna.matkustus) {

      if (!juna.veturi) errors.veturi = "Veturin numero on pakollinen";
      if (!juna.akselit) errors.akselit = "Akselien lukumäärä on pakollinen";
      if (!juna.pituus) errors.pituus = "Pituus on pakollinen";
      if (!juna.junapaino) errors.junapaino = "Junan paino on pakollinen";
      if (!juna.JP) errors.JP = "JP on pakollinen";
      if (!juna.JPP) errors.JPP = "JPP on pakollinen";
      if (!juna.lahtoaika) errors.lahtoaika = "Lähtöaika on pakollinen";
      if (!juna.saapumisaika) errors.saapumisaika = "Saapumisaika on pakollinen";

    }


    setNewErrors(errors);

    if (Object.keys(errors).length === 0) {


      setjarjestysNum(props.suurinJarjestysNum)


      const uusiJuna = {
        id: junat.length + 1,
        junanumero: juna.junanumero,
        pvm: juna.pvm,
        mista: selectedStation,
        mihin: selectedStationTo,
        veturi: juna.veturi,
        akselit: juna.akselit,
        pituus: juna.pituus,
        junapaino: juna.junapaino,
        JP: juna.JP,
        JPP: juna.JPP,
        lahtoaika: juna.lahtoaika,
        saapumisaika: juna.saapumisaika,
        lahtoaikam: juna.lahtoaikam,
        saapumisaikam: juna.saapumisaikam,
        kmM: juna.kmM,
        kmT: juna.kmT,
        vapaateksti: juna.vapaateksti,
        jarjestysNum: jarjestysNum,
        matkustus: juna.matkustus,
      };

      if (uusiJuna.lahtoaikam === null) {
        uusiJuna.lahtoaikam = 0;
      }

      if (uusiJuna.saapumisaikam === null) {
        uusiJuna.saapumisaikam = 0;
      }

      setJunat(prevJunat => [...prevJunat, uusiJuna]);



      alert("Juna: " + juna.junanumero + " lisättiin. Lisää toinen juna tai tallenna työvuoro");



      if (scrolli.current) {
        scrolli.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }

      setJuna({
        ...juna,
        pvm: new Date(),
        junanumero: 0,
        mista: '',
        mihin: '',
        kmM: 0,
        kmT: 0,
        veturi: 0,
        akselit: 0,
        pituus: 0,
        junapaino: 0,
        JP: 0,
        JPP: 0,
        lahtoaika: new Date(),
        saapumisaika: new Date(),
        lahtoaikam: 0,
        saapumisaikam: 0,
        matkustus: false,
      });

      setSelectedStation(selectedStationTo);
      setSelectedStationTo("");
      setjarjestysNum(jarjestysNum + 1);




      setMatkatunnit("");
      setSelectedJunaId(0);
      setMuotoiltuAikavali('');







    }
    else {
      alert("Täytä vielä punaisella merkityt kentät");

    }






  };




  const uniqueStations = asematiedot?.timeTableRows
    ?.filter(row => row.trainStopping)
    .map(row => row.stationShortCode)
    .filter((station, index, array) => index === 0 || station !== array[index - 1]) || []; // Poistaa vain peräkkäiset duplikaatit


  /*
    const uniqueStations = asematiedot?.timeTableRows
      .filter(row => row.trainStopping) // Suodatetaan vain pysähtymiset
      .map(row => row.stationShortCode) || [];
      */



  const selectedDepartureIndex = uniqueStations.indexOf(selectedStation);

  const uniqueStationsTo = uniqueStations.filter((station, index) => {
    return index > selectedDepartureIndex;
  });


  useEffect(() => {

    setTemplateJuna([]);



    const alkuKlo = vuoro.vuoroalkaa.toTimeString().slice(0, 5); // esim. "08:30"
    const loppuKlo = vuoro.vuoroloppuu.toTimeString().slice(0, 5); // esim. "16:15"

    const onkoOlemassaTeeTemplate = async () => {
      try {
        const response = await fetch(`/api/ajot/tarkista-vuoro?userid=${props.kayttajaId}&kloAlku=${alkuKlo}&kloLoppu=${loppuKlo}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${props.token}` // Lisää token Authorization-otsakkeeseen
          }
        });

        if (!response.ok) {
          throw new Error("Virhe palvelimella");
        }

        const data = await response.json();

        if (data.vuorot.length > 0) {
          //  console.log("Löydetyt vuorot:", data.vuorot);

          data.vuorot.forEach((vuoro: any) => {
            //  console.log("Vuoro:", vuoro);
            //  console.log("Junat tässä vuorossa:", vuoro.junat);
          });

          setTemplateJuna(data.vuorot); // Tallennetaan haetut junat tilaan

        } else {
          console.log("Ei päällekkäisiä vuoroja.");
        }



      } catch (error) {
        console.error("Virhe tarkistettaessa vuoroa:", error);
      }
    };




    const aikavaliMs = vuoro.vuoroloppuu.getTime() - vuoro.vuoroalkaa.getTime(); // Aikaväli millisekunteina
    const tunnit = Math.floor(aikavaliMs / (1000 * 3600)); // Kokonaiset tunnit
    const minuutit = Math.floor((aikavaliMs % (1000 * 3600)) / (1000 * 60)); // Jäljelle jäävät minuutit


    setMuotoiltuAikavali(aikavaliMs >= 0 ? `${tunnit} h ${minuutit} min` : 'Virheellinen aika')

    setMatkatunnit(`${tunnit} h`);




    if (aikavaliMs > 0) {
      setAikavalittu(true);

      onkoOlemassaTeeTemplate();

    }


    vuoro.tyoaika = differenceInMinutes(vuoro.vuoroloppuu, vuoro.vuoroalkaa);
    vuoro.matkatunnit = tunnit;

  }, [vuoro.vuoroalkaa, vuoro.vuoroloppuu]);






  const laskeYoTyo = (vuoroAlkaa: string | number | Date, vuoroLoppuu: string | number | Date) => {
    const alku = new Date(vuoroAlkaa);
    const loppu = new Date(vuoroLoppuu);
    let totalMinutes = 0;
    let yotyoAlku = new Date(alku);
    let yotyoLoppu = new Date(loppu);
    ///*** Vuoro alkaa ja loppuu samana päivänä */



    // Yötyötä on 00 - 6 tai 12 välillä
    if (alku.getDate() === loppu.getDate()) {
      yotyoAlku.setHours(0, 0, 0, 0); // yötyö alkaa klo 00:00
      if (alku.getHours() < 4) {
        yotyoLoppu.setHours(12, 0, 0, 0); // yötyö loppuu klo 12:00 
      }
      else {
        yotyoLoppu.setHours(6, 0, 0, 0); // yötyö loppuu klo 6:00 
      }
      if (yotyoLoppu >= loppu && yotyoAlku <= alku) {
        totalMinutes = differenceInMinutes(loppu, alku);
      }
      if (yotyoLoppu < loppu && yotyoAlku <= alku) {
        totalMinutes = differenceInMinutes(yotyoLoppu, alku);
      }




      if (yotyoLoppu >= loppu && yotyoAlku <= alku) {
        totalMinutes = differenceInMinutes(loppu, alku);
      }
      if (yotyoLoppu < loppu && yotyoAlku <= alku) {
        totalMinutes = differenceInMinutes(yotyoLoppu, alku);
      }


      // Toinen case... Yötyötä on 21-24 välillä

      if (loppu.getHours() > 20) {
        yotyoAlku.setHours(21, 0, 0, 0); // yötyö alkaa klo 21:00
        totalMinutes = differenceInMinutes(loppu, yotyoAlku);

      }

      if (alku.getHours() >= 21) {

        totalMinutes = differenceInMinutes(loppu, alku);

      }





    }
    ///*** Vuoro alkaa ja loppuu eri päivinä */
    else if (alku.getDate() < loppu.getDate()) {
      yotyoAlku.setHours(21, 0, 0, 0); // yötyö alkaa klo 21:00
      yotyoLoppu.setHours(12, 0, 0, 0); // yötyö loppuu klo 12:00  seuraavana päivänä
      totalMinutes = differenceInMinutes(loppu, alku);
      if (alku < yotyoAlku) {
        totalMinutes = differenceInMinutes(loppu, yotyoAlku);
      }
      if (loppu > yotyoLoppu) {
        totalMinutes = differenceInMinutes(yotyoLoppu, alku);
      }
      if (alku < yotyoAlku && loppu > yotyoLoppu) {
        totalMinutes = differenceInMinutes(yotyoLoppu, yotyoAlku);
      }
    }
    if (totalMinutes < 0) {
      totalMinutes = 0;
    }

    vuoro.yotunnit = totalMinutes;
    const tunnit = Math.floor(totalMinutes / 60);
    const minuutit = totalMinutes % 60;
    return { tunnit: tunnit, minuutit: minuutit };
  };


  const laskeIltaTyo = (vuoroAlkaa: string | number | Date, vuoroLoppuu: string | number | Date) => {
    const alku = new Date(vuoroAlkaa);
    const loppu = new Date(vuoroLoppuu);
    let totalMinutes = 0;

    const yotyoAlku = new Date(alku);
    yotyoAlku.setHours(18, 0, 0, 0);

    const yotyoLoppu = new Date(alku);
    yotyoLoppu.setHours(20, 0, 0, 0);

    totalMinutes = Math.min(differenceInMinutes(yotyoLoppu, alku), differenceInMinutes(loppu, yotyoAlku), differenceInMinutes(yotyoLoppu, yotyoAlku));

    if (totalMinutes < 0) {
      totalMinutes = 0;
    }




    vuoro.iltatunnit = totalMinutes;

    const tunnit = Math.floor(totalMinutes / 60);
    const minuutit = totalMinutes % 60;
    return { tunnit: tunnit, minuutit: minuutit };
  };




  const laskeLauantaitunnit = (vuoroAlkaa: string | number | Date, vuoroLoppuu: string | number | Date) => {

    let totalMinutes = 0;
    const alku = new Date(vuoroAlkaa);
    const loppu = new Date(vuoroLoppuu);


    // ******** vuoro alkaa lauantaina

    if (isSaturday(alku)) {

      const lauantaiTunnitLoppuu = setHours(setMinutes(alku, 0), 18);


      if (alku.getHours() >= 8) {
        if (isSaturday(loppu)) {
          if (loppu.getHours() < 18) {
            totalMinutes = differenceInMinutes(loppu, alku);
          }

          else {
            totalMinutes = differenceInMinutes(lauantaiTunnitLoppuu, alku);
          }

        }
        /// Jos työvuoro jatkuu sunnuntain puolelle
        else {
          totalMinutes = differenceInMinutes(lauantaiTunnitLoppuu, alku);
        }

      }
    }

    // ********** Vuoro alkaa muuna päivänä ja jatkuu lauantaille
    else {
      const lauantaitunnitAlkaa = setHours(setMinutes(loppu, 0), 8);
      const lauantaiTunnitLoppuu = setHours(setMinutes(loppu, 0), 18);

      if (loppu.getHours() >= 8) {
        if (isSaturday(loppu)) {
          if (loppu.getHours() < 18) {
            totalMinutes = differenceInMinutes(loppu, lauantaitunnitAlkaa);
          }

          else {
            totalMinutes = differenceInMinutes(lauantaiTunnitLoppuu, lauantaitunnitAlkaa);
          }

        }

      }
    }

    if (totalMinutes < 0) {
      totalMinutes = 0;
    }
    if (totalMinutes > 600) {
      totalMinutes = 600;
    }


    vuoro.latunnit = totalMinutes;


    const tunnit = Math.floor(totalMinutes / 60);
    const minuutit = totalMinutes % 60;
    return { tunnit: tunnit, minuutit: minuutit };
  };


  const laskeSunnuntaitunnit = (vuoroAlkaa: string | number | Date, vuoroLoppuu: string | number | Date) => {

    let totalMinutes = 0;
    const alku = new Date(vuoroAlkaa);
    const loppu = new Date(vuoroLoppuu);





    if (isSunday(alku)) {

      const sunnuntaiTunnitLoppuu = setHours(setMinutes(alku, 59), 23);

      if (isSunday(loppu)) {

        totalMinutes = differenceInMinutes(loppu, alku);

      }

      else {

        totalMinutes = differenceInMinutes(sunnuntaiTunnitLoppuu, alku);
      }

    }


    // ******** vuoro alkaa lauantaina


    if (isSaturday(alku)) {
      const SunnuntaitunnitAlkaa = setHours(setMinutes(alku, 0), 18); // su tunnit lasketaan la klo 18 lähtien

      totalMinutes = differenceInMinutes(loppu, SunnuntaitunnitAlkaa);

    }


    if (totalMinutes < 0) {
      totalMinutes = 0;
    }

    vuoro.sutunnit = totalMinutes;


    const tunnit = Math.floor(totalMinutes / 60);
    const minuutit = totalMinutes % 60;
    return { tunnit: tunnit, minuutit: minuutit };
  };



  return (

    <Container>


      <Paper>
        <Box padding={2}>

          <Typography variant="h4" gutterBottom>
            Työvuoro
          </Typography>

          <Typography variant="body1">
            Matkatyövuorossa merkitse molemmat vuoron osat erikseen.
          </Typography>



          <TextField
            label="Työvuoro alkaa"
            name="vuoroAlkaa"
            type="datetime-local"
            value={format(new Date(vuoro.vuoroalkaa), "yyyy-MM-dd'T'HH:mm")}
            onChange={(e) => setVuoro({
              ...vuoro,
              vuoroalkaa: new Date(e.target.value),
            })}
            fullWidth
            margin="normal"
          />



          <TextField
            label="Työvuoro päättyy"
            name="vuoroLoppuu"
            type="datetime-local"
            value={format(new Date(vuoro.vuoroloppuu), "yyyy-MM-dd'T'HH:mm")}
            onChange={(e) => setVuoro({
              ...vuoro,
              vuoroloppuu: new Date(e.target.value),
            })}
            fullWidth
            margin="normal"
          />

          {templateJuna.length > 0 ? (
            <>
              <Typography variant="body1"> Samalle työajalle aiemmin lisätyt junat</Typography>
              <div style={{ padding: 0 }}>
                {templateJuna
                  .map((vuoro) => vuoro.junat)
                  .flat() // Flatten the array of arrays
                  .filter(
                    (juna, index, self) =>
                      index === self.findIndex((t) => t.junanumero === juna.junanumero) // Remove duplicates based on `junanumero`
                  )
                  .map((juna) => (
                    <div
                      key={juna.id}
                      style={{
                        backgroundColor: templateSelectedJunaId.includes(juna.id) ? "#255222" : "transparent",
                        marginTop: "10px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          color: "#A0A0A0",
                          fontSize: "1.7rem",
                          fontWeight: "bold",
                          textAlign: "center",
                          width: "40px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      ></div>

                      <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                        <div style={{ marginBottom: "10px" }}>
                          {new Date(juna.lahtoaika).toLocaleString("fi-FI", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                          {" - "}
                          {new Date(juna.saapumisaika).toLocaleString("fi-FI", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </div>

                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "fit-content",
                              height: "40px",
                              borderRadius: "10px",
                              backgroundColor: "#388E3C",
                              color: "#fff",
                              fontWeight: "bold",
                              fontSize: "1rem",
                              padding: "10px",
                            }}
                          >
                            {juna.junanumero} : {juna.mista} - {juna.mihin}
                          </div>

                          <div style={{ marginLeft: "5px" }}>
                            <IconButton
                              onClick={() => toggleJunaSelection(juna)}
                              aria-label="add"
                              color="primary"
                            >
                              <AddIcon /> {templateSelectedJunaId.includes(juna.id) ? "Lisätty" : "Lisää"}
                            </IconButton>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </>
          ) : null}


          <TableContainer component={Paper}>
            {aikavalittu ? (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant="h6"> Tuntijakauma </Typography>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>Työvuoron kesto</TableCell>
                    <TableCell>
                      <Typography variant="h6">{muotoiltuAikavali}</Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Lauantaitunnit</TableCell>
                    <TableCell>
                      <Typography variant="h6">
                        {laskeLauantaitunnit(vuoro.vuoroalkaa.toString(), vuoro.vuoroloppuu.toString()).tunnit} h {laskeLauantaitunnit(vuoro.vuoroalkaa.toString(), vuoro.vuoroloppuu.toString()).minuutit} min

                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Sunnuntaitunnit</TableCell>
                    <TableCell>
                      <Typography variant="h6">
                        {laskeSunnuntaitunnit(vuoro.vuoroalkaa.toString(), vuoro.vuoroloppuu.toString()).tunnit} h {laskeSunnuntaitunnit(vuoro.vuoroalkaa.toString(), vuoro.vuoroloppuu.toString()).minuutit} min
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Iltatyö</TableCell>
                    <TableCell>
                      <Typography variant="h6">{laskeIltaTyo(vuoro.vuoroalkaa.toString(), vuoro.vuoroloppuu.toString()).tunnit} h {laskeIltaTyo(vuoro.vuoroalkaa.toString(), vuoro.vuoroloppuu.toString()).minuutit} min</Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Yötyö</TableCell>
                    <TableCell>
                      <Typography variant="h6">{laskeYoTyo(vuoro.vuoroalkaa.toString(), vuoro.vuoroloppuu.toString()).tunnit} h {laskeYoTyo(vuoro.vuoroalkaa.toString(), vuoro.vuoroloppuu.toString()).minuutit} min</Typography>
                    </TableCell>
                  </TableRow>

                </TableBody>
                <TableRow>
                  <TableCell>Matkatunnit</TableCell>
                  <TableCell>
                    <Typography variant="h6">
                      {matkatunnit}

                    </Typography>
                  </TableCell>
                </TableRow>
              </Table>
            ) : null}
          </TableContainer>

          {/* Render the entries */}
          <br />





          {junat.length > 0 ? (
            <Box>
              <Typography variant="body2" color="lightblue" sx={{ mb: 2 }}>
                (Huom! Muokkauksia ei ole tallennettu)
              </Typography>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Työvuoron junat:
              </Typography>
              <Box display="flex" flexDirection="column" gap={2}>
                {junat.map((tyovuoronjuna) => (
                  <Paper
                    key={tyovuoronjuna.id}
                    elevation={selectedJunaId === tyovuoronjuna.id ? 6 : 2}
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 2,
                      backgroundColor: selectedJunaId === tyovuoronjuna.id ? "#255222" : "background.paper",
                    }}
                  >

                    <Box flex={1} display="flex" flexDirection="column">
                      <Box display="inline-flex" alignItems="center">
                        <Typography
                          variant="h6"
                          color="text.primary"
                          sx={{
                            mb: 1,
                            display: 'inline',
                            fontWeight: 'bold', // Paksu fontti
                            textShadow: '1px 1px 4px rgba(255, 255, 255, 0.3)', // Vaalea varjo efektinä
                            backgroundColor: '#333', // Tumma taustaväri
                            color: '#fff', // Valkoinen teksti
                            px: 2, // Sisätilan säätö
                            borderRadius: 1, // Pyöristetyt kulmat
                          }}
                        >
                          {tyovuoronjuna.jarjestysNum}
                        </Typography>


                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1, display: 'inline', ml: 1 }}>

                          {new Date(tyovuoronjuna.pvm).toLocaleString("fi-FI", {
                            weekday: "short",
                            month: "2-digit",
                            day: "2-digit",
                          })}
                          {" klo "}
                          {new Date(tyovuoronjuna.lahtoaika).toLocaleString("fi-FI", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                          {tyovuoronjuna.lahtoaikam ? (
                            <Box component="span" sx={{ color: "#FF6F61" }}> (+{tyovuoronjuna.lahtoaikam} min) </Box>
                          ) : null}
                          {" - "}
                          {new Date(tyovuoronjuna.saapumisaika).toLocaleString("fi-FI", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                          {tyovuoronjuna.saapumisaikam ? (
                            <Box component="span" sx={{ color: "#FF6F61" }}> (+{tyovuoronjuna.saapumisaikam} min) </Box>
                          ) : null}
                        </Typography>
                      </Box>

                      <Box display="flex" alignItems="center" gap={1}>
                        <Box
                          sx={{
                            bgcolor: "#388E3C",
                            color: "white",
                            fontWeight: "bold",
                            borderRadius: 2,
                            px: 2,
                            py: 1,
                          }}
                        >
                          {tyovuoronjuna.junanumero} : {tyovuoronjuna.mista} - {tyovuoronjuna.mihin}
                        </Box>
                        <IconButton onClick={() => handleEdit(tyovuoronjuna.id)} color="primary" disabled={selectedJunaId !== 0}>
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => handleDelete(tyovuoronjuna.id)} color="secondary" disabled={selectedJunaId !== 0}>
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        Veturi: {tyovuoronjuna.veturi} |
                        Akselit: {tyovuoronjuna.akselit} |
                        Pituus: {tyovuoronjuna.pituus} |
                        Paino: {tyovuoronjuna.junapaino} |
                        JP: {tyovuoronjuna.JP} |
                        JPP: {tyovuoronjuna.JPP} |
                        {tyovuoronjuna.kmM ? ` km: ${tyovuoronjuna.kmM} | ` : ""}
                        {tyovuoronjuna.kmT ? ` km: ${tyovuoronjuna.kmT} | ` : ""}

                      </Typography>
                    </Box>
                  </Paper>
                ))}
              </Box>
              <FormControlLabel
                control={<Checkbox name="tsl" checked={vuoro.tsl} onChange={handleChange} />}
                label="Vuorossa on lepo / TSL"
                sx={{ mt: 2 }}
              />
              {!selectedJunaId && (
                <Button variant="contained" color="primary" onClick={handleTallennaTyovuoro} sx={{ mt: 2 }}>
                  Tallenna työvuoro
                </Button>
              )}
            </Box>
          ) : null}




        </Box>

      </Paper>





      <br />
      <br />



      {aikavalittu && (

        <form onSubmit={handleSubmit}>

          <Paper>
            <Box padding={2}>
              <div style={{ display: 'flex', justifyContent: 'center' }}>

                {selectedJunaId ? (
                  <Typography variant="h6" style={{ color: "orange" }}>
                    Muokkaa junaa:
                  </Typography>
                ) : (
                  <Typography variant="h6" style={{ color: "green" }}>
                    Luo uusi:
                  </Typography>
                )}
              </div>



              <Typography ref={scrolli} variant="h5" gutterBottom>
                <Stack direction="column" spacing={1}>





                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '10px' }}>
                    <Typography variant="h6">
                      {jarjestysNum}. Juna
                    </Typography>

                    <SwapHorizIcon
                      sx={{ margin: '5px' }}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        const newNumber = prompt(
                          "Anna junalle uusi järjestysnumero",
                          jarjestysNum.toString()
                        );
                        if (newNumber) {
                          setjarjestysNum(parseInt(newNumber, 10));
                        }
                      }}
                    />
                  </div>

                  <hr style={{ margin: '10px 0' }} />






                  <FormControlLabel
                    control={
                      <Checkbox
                        name="matkustus"
                        checked={juna.matkustus}
                        onChange={handleChangeJuna}
                      />
                    }
                    label="Pakettimatka?"
                  />
                </Stack>
              </Typography>

              <TextField
                label="Päivämäärä"
                name="pvm"
                type="date"
                value={juna.pvm.toISOString().split('T')[0] || ""}
                onChange={(e) => setJuna({ ...juna, pvm: new Date(e.target.value) })}
                fullWidth
                margin="normal"
                error={!!newErrors.pvm}
                helperText={newErrors.pvm}

              />
              <TextField
                label="Junanumero"
                name="junanumero"
                type="number"
                value={juna.junanumero || ""}
                onChange={handleChangeJuna}
                fullWidth
                margin="normal"
                error={!!newErrors.junanumero}
                helperText={newErrors.junanumero}

              />

              {asematiedot && asematiedot.timeTableRows && (
                <>
                  <FormControl fullWidth margin="normal">
                    <InputLabel id="station-select-label-from">Lähtöasema</InputLabel>
                    <Select
                      labelId="station-select-label-from"
                      name="mista"
                      value={selectedStation || ""}
                      onChange={handleStationChange}
                      error={!!newErrors.mista}
                    >
                      {uniqueStations.length > 0 ? (
                        uniqueStations.map((station) => (
                          <MenuItem key={station} value={station}>
                            {station}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>Ei asematietoja</MenuItem>
                      )}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth margin="normal">
                    <InputLabel id="station-select-label-to">Määräasema</InputLabel>
                    <Select
                      labelId="station-select-label-to"
                      name="mihin"
                      value={selectedStationTo || ""}
                      onChange={handleStationChangeTo}
                      error={!!newErrors.mihin}
                    >
                      {uniqueStationsTo.length > 0 ? (
                        uniqueStationsTo.map((station) => (
                          <MenuItem key={station} value={station}>
                            {station}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>Ei asematietoja</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </>
              )}

              <TextField
                label="kilometrit (Matkustajajuna)"
                name="kmM"
                type="number"
                value={juna.kmM || ""}
                onChange={handleChangeJuna}
                fullWidth
                margin="normal"

              />


              <TextField
                label="kilometrit (Tavarajuna)"
                name="kmT"
                type="number"
                value={juna.kmT || ""}
                onChange={handleChangeJuna}
                fullWidth
                margin="normal"

              />





              <TextField
                label="Veturin numero"
                name="veturi"
                type="number"
                value={juna.veturi || ""}
                onChange={handleChangeJuna}
                fullWidth
                margin="normal"
                error={!!newErrors.veturi}
                helperText={newErrors.veturi}
              />
              <TextField
                label="Akselit"
                name="akselit"
                type="number"
                value={juna.akselit || ""}
                onChange={handleChangeJuna}
                fullWidth
                margin="normal"
                error={!!newErrors.akselit}
                helperText={newErrors.akselit}
              />
              <TextField
                label="Pituus"
                name="pituus"
                type="number"
                value={juna.pituus || ""}
                onChange={handleChangeJuna}
                fullWidth
                margin="normal"
                error={!!newErrors.pituus}
                helperText={newErrors.pituus}
              />
              <TextField
                label="Junan paino"
                name="junapaino"
                type="number"
                value={juna.junapaino || ""}
                onChange={handleChangeJuna}
                fullWidth
                margin="normal"
                error={!!newErrors.junapaino}
                helperText={newErrors.junapaino}
              />
              <TextField
                label="JP"
                name="JP"
                type="number"
                value={juna.JP || ""}
                onChange={handleChangeJuna}
                fullWidth
                margin="normal"
                error={!!newErrors.JP}
                helperText={newErrors.JP}
              />
              <TextField
                label="JPP"
                name="JPP"
                type="number"
                value={juna.JPP || ""}
                onChange={handleChangeJuna}
                fullWidth
                margin="normal"
                error={!!newErrors.JPP}
                helperText={newErrors.JPP}
              />




              <TextField
                label="Aikataulunmukainen Lähtöaika"
                name="lahtoaika"
                type="time"
                value={format(juna.lahtoaika, 'HH:mm') || ""}
                onChange={(e) => {
                  const [hours, minutes] = e.target.value.split(':');
                  const localDepartureTime = new Date();
                  localDepartureTime.setHours(Number(hours), Number(minutes), 0, 0);
                  setJuna({ ...juna, lahtoaika: localDepartureTime });
                }}
                fullWidth
                margin="normal"
                error={!!newErrors.lahtoaika}
                helperText={newErrors.lahtoaika}
              />

              <TextField
                label={`Lähti myöhässä? (${selectedStation})`}
                name="Mlahtoaika"
                type="number"
                value={juna.lahtoaikam < 0 ? 0 : juna.lahtoaikam || ""}

                onChange={(e) => {
                  setJuna({ ...juna, lahtoaikam: Number(e.target.value) });
                }}
                fullWidth
                margin="normal"
              />


              <TextField
                label="Aikataulunmukainen Saapumisaika"
                name="saapumisaika"
                type="time"
                value={format(juna.saapumisaika, 'HH:mm') || ""}
                onChange={(e) => {
                  const [hours, minutes] = e.target.value.split(':');
                  const localArrivalTime = new Date();
                  localArrivalTime.setHours(Number(hours), Number(minutes), 0, 0);
                  setJuna({ ...juna, saapumisaika: localArrivalTime });
                }}
                fullWidth
                margin="normal"
                error={!!newErrors.saapumisaika}
                helperText={newErrors.saapumisaika}
              />



              <TextField
                label={`Saapui myöhässä? (${selectedStationTo})`}
                name="Msaapumisaika"
                type="number"
                value={juna.saapumisaikam < 0 ? 0 : juna.saapumisaikam || ""}
                onChange={(e) => {
                  setJuna({ ...juna, saapumisaikam: Number(e.target.value) });
                }}
                fullWidth
                margin="normal"
              />


              <TextField
                label="Vapaa teksti"
                name="vapaateksti"
                multiline
                rows={4}
                value={juna.vapaateksti || ""}
                onChange={(e) => {
                  setJuna({ ...juna, vapaateksti: e.target.value });
                }}
                fullWidth
                margin="normal"
              />










              <div style={{ display: 'flex', gap: '8px' }}>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  onClick={selectedJunaId ? peruutaMuokkaus : lisaaTyovuoroon}
                >
                  {selectedJunaId ? "Peruuta" : "Lisää juna työvuoroon"}
                </Button>

                {selectedJunaId ? (
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={() => handleEdit(selectedJunaId)}
                  >
                    Hyväksy muokkaukset
                  </Button>
                ) : null}
              </div>






            </Box>
          </Paper>


        </form>
      )
      }


    </Container >

  );
};

export default Kirjaa;
